<template>
  <div id="GoodsModule">
    <!-- 公司信息横幅 -->
    <div class="company-banner">
      <div
          class="company-logo-large"
          :style="{ 'background': 'url('+ getFileUrl($route.query.supplierCompanyLogo || '') +')', 'background-size': 'cover'}"
      ></div>
      <div class="company-info">
        <div class="company-name">
          {{ $route.query.name || '' }}
        </div>
        <div>
          <i style="margin-right: 8px"><img src="@/assets/icon/my.png" style="width: 17px;margin-bottom: 4px;" /></i>
          <span style="font-size: 14px;color: #7f8c8d;">{{ $route.query.person || '' }}</span>
        </div>
        <div>
          <i style="margin-right: 8px"><img src="@/assets/icon/phone.png" style="width: 17px;margin-bottom: 4px;" /></i>
          <span style="font-size: 14px;color: #7f8c8d;">{{ $route.query.phone || '' }}</span>
        </div>
<!--        <div class="company-stats">-->
<!--          <div class="stat-item">-->
<!--            <div class="stat-value">28</div>-->
<!--            <div class="stat-label">可兑换商品</div>-->
<!--          </div>-->
<!--          <div class="stat-item">-->
<!--            <div class="stat-value">1,250+</div>-->
<!--            <div class="stat-label">成功兑换</div>-->
<!--          </div>-->
<!--          <div class="stat-item">-->
<!--            <div class="stat-value">4.9 <i class="fas fa-star"></i></div>-->
<!--            <div class="stat-label">用户评分</div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <!-- 商品列表区域 -->
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">积分商品</h2>
      </div>

      <div class="products-grid">
        <!-- 商品1 -->
        <div class="product-card" v-for="(item, index) in goodsList" :key="item.id" @click="goDetail(item)">
          <div class="product-image">
            <div class="img-placeholder">
              <img :src="getFileUrl(item.bridgePicUrl) || '/noimage.png'"  />
            </div>
<!--            <div class="product-tag">热销</div>-->
<!--            <div class="product-tag" v-if="index === 0">热销</div>-->
          </div>
          <div class="product-info">
            <div class="product-name">
              <a-popover :content="item.name">{{ item.name }}</a-popover>
            </div>
            <div class="product-points">
              <div class="points-value"> <i><img src="@/assets/icon/jifen2.png" style="width: 17px;margin-bottom: 4px;" /></i> {{ item.points }}</div>
              <button class="exchange-btn">兑换</button>
            </div>
          </div>
        </div>
        <a-empty style="margin: 50px auto 0" v-if="!goodsList.length"/>
      </div>
    </div>
<!--    <div class="goods-module">-->
<!--      <div v-for="item in goodsList" :key="item.id" class="goods-card" @click="goDetail(item)">-->
<!--        <div class="goods-img">-->
<!--          <img :src="getFileUrl(item.bridgePicUrl) || '/noimage.png'" class="img">-->
<!--        </div>-->
<!--        <div class="item_name">-->
<!--          <div class="name" :style="{ 'line-height' : item?.brandName?.length < 19 ? '3em' : '1.5em' }">{{ item.name }}</div>-->
<!--        </div>-->

<!--        <div class="item_price">-->
<!--          <span class="price">{{ item.points }}</span><span>积分</span>-->
<!--          <a-icon type="transaction" />-->
<!--&lt;!&ndash;          <span>兑换</span>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--      <a-empty style="margin: 50px auto 0" v-if="!goodsList.length"/>-->
<!--    </div>-->
    <div class="pagination">
      <a-pagination :total="total" :defaultPageSize="8" @change="paginationChange"/>
    </div>
  </div>
</template>
<script>
import {insertCart} from "@/api/mall";
import fileUrlMixin from "@/mixins/fileUrlMixin";

export default {
  mixins: [fileUrlMixin],
  props: {
    goodsList: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    paginationChange (current) {
      this.$emit('paginationChange', current)
    },
    goDetail (item) {
      this.$router.push({
        path: `/goodsDetail`,
        query: {
          id: item.id,
          name: this.$route.query?.name || '',
          cid: item.companyId
        }
      })
    },
    addCart (item) {
      insertCart({goodsId: item.id, count: 1}).then(res => {
        if (!res.code) {
          this.$message.success('加入成功')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>

/* 公司信息横幅 */
.company-banner {
  max-width: 1200px;
  margin: 30px auto;
  background: white;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 25px;
}

.company-logo-large {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  background: linear-gradient(135deg, #ff9a9e, #fad0c4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 36px;
  font-weight: bold;
  flex-shrink: 0;
}

.company-info {
  flex: 1;
}

.company-name {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #2c3e50;
}

.company-stats {
  display: flex;
  gap: 30px;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
}

.stat-label {
  font-size: 14px;
  color: #7f8c8d;
}

/* 商品列表 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0 20px;
}

.section-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  position: relative;
  padding-bottom: 10px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #ff9a9e, #fad0c4);
  border-radius: 2px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  margin-bottom: 40px;
}

.product-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.product-image {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa, #e4edf9);
  position: relative;
}

.product-image .img-placeholder {
  font-size: 48px;
  color: #a1c4fd;
  img{
    width: 100%;
    height: 200px;
    line-height: 156px;
    overflow: hidden;
    display: flex;
    justify-content: center;
  }
}

.product-tag {
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, #ff9a9e, #fad0c4);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.product-info {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #2c3e50;

  overflow: hidden;               /* 隐藏超出部分的内容 */
  text-overflow: ellipsis;        /* 使用省略号显示溢出的文本 */
  display: -webkit-box;           /* 必须使用 Webkit box 显示多行文本 */
  -webkit-line-clamp: 1;          /* 设置显示的行数，这里是3行 */
  -webkit-box-orient: vertical;   /* 设置排列方向为纵向 */
}

.product-desc {
  color: #7f8c8d;
  font-size: 14px;
  margin-bottom: 15px;
  flex: 1;
}

.product-points {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px dashed #e0e6ed;
}

.points-value {
  font-weight: 700;
  color: #e74c3c;
  font-size: 20px;
}

.points-value i {
  margin-right: 5px;
  color: #ffd700;
}

.exchange-btn {
  //background: linear-gradient(135deg, #84fab0, #8fd3f4);
  background: linear-gradient(135deg, #a1c4fd, #c2e9fb);
  //color: #2c3e50;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.exchange-btn:hover {
  opacity: 0.9;
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

/*
  ---------------------------------------
*/

.goods-module{
  display: flex;
  flex-wrap: wrap;
  min-height: 250px;
  //gap: 30px;
  gap: 30px;
}
.goods-card:hover{
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
}
.goods-card{
  //width: 230px;
  width: 216px;
  padding: 15px 10px;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);
  .goods-img {
    width: 100%;
    //height: 230px;
    //line-height: 230px;
    height: 156px;
    line-height: 156px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    .img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .item_name{
    margin: 10px 0;
    color: #333;
    .name {
      //height: 40px;
      //overflow: hidden;
      //display: -webkit-box;
      //-webkit-box-orient: vertical;
      //-webkit-line-clamp: 2;
      //line-height: 20px;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%
    }
  }
  .item_price{
    color: #333333;
    .price{
      font-size: 22px;
      font-weight: 550;
      margin-right: 5px;
      color: #de0000;
    }
    .anticon-transaction{
      float: right;
      font-size: 22px;
      margin-top: 6px;
    }
    .anticon{
    }
  }
}
.pagination{
  margin: 20px 0;
  padding: 10px;
  display: flex;
  justify-content: center;
}
</style>
